import { MusicForAdhdPageContent } from '../../components/pages/music-for-adhd';
import Layout from '../../components/shared/Layout';
import { usePageVistTracker } from '../../hooks/usePageVistTracker';

const MusicForAdhd: React.FC = () => {
  usePageVistTracker();

  return (
    <Layout pageTitle="Music for ADHD">
      <MusicForAdhdPageContent/>
    </Layout>
  );
};

export default MusicForAdhd;
